import { render, staticRenderFns } from "./DeletePaymentDetail.vue?vue&type=template&id=4d72d8c3"
import script from "./DeletePaymentDetail.vue?vue&type=script&lang=js"
export * from "./DeletePaymentDetail.vue?vue&type=script&lang=js"
import style0 from "./DeletePaymentDetail.vue?vue&type=style&index=0&id=4d72d8c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports